import { InterpolatedTranslatePipe } from '../pipe/interpolated-translate.pipe';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { cassiopeiaIcons } from '@nestech/utils';
import { EnvironmentService } from '@web/service';
import { Button } from '../button';
import { Card, CardContainer, CardHeader } from './card';
import { Page } from './page';
import { TopNavigationComponent } from './top-navigation';

@Component({
  selector: 'cas-not-allowed',
  imports: [
    Button,
    TopNavigationComponent,
    Card,
    CardContainer,
    CardHeader,
    Page,
    InterpolatedTranslatePipe,
    FaIconComponent,
  ],
  template: `
    <cas-top-navigation
      withMenuToggle="false"
      withProfileInfo="false" />
    <main class="d-flex flex-column w-100 h-100 justify-content-between">
      <cas-page>
        <cas-card-container xxlCols="1">
          <cas-card>
            <cas-card-header
              name="cas.notAllowedHeader"
              description="cas.notAllowedBody" />
            <footer>
              <cas-button
                theme="primary"
                (click)="callUs()">
                <fa-icon [icon]="phoneIcon" />
                {{ 'cas.callUs' | translate }}
              </cas-button>
            </footer>
          </cas-card>
        </cas-card-container>
      </cas-page>
    </main>
  `,
  styles: `
    :host {
      height: 100vh;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotAllowed {
  #environment = inject(EnvironmentService).environment;
  protected readonly phoneIcon = cassiopeiaIcons.phone;

  protected callUs() {
    window.open(`tel:${this.#environment.contactInfo.phone}`, '_self');
  }
}
